export const ru = {
    'deleted-success': 'Условие ретаргетинга удалено',
    'error-delete-retargeting-list-item': 'Не удалось удалить условие ретаргетинга'
};
